import shopifyGenericDefaults from '../shopify-generic/config.js';

const searchPageUrl = window.Convermax.Shopify?.getSearchPageUrl() ?? '/pages/search';
const isSearchPage = window.location.pathname === searchPageUrl;
const pageType = window.Convermax.Shopify?.getPageType();
const isCollectionPage = pageType === 'collection' || pageType === 'collections';
const isMiniStoreCollectionPage = window.document.querySelector('#cm-mini-change-button');

export default {
  includes: ['shopify-generic'],
  ...shopifyGenericDefaults,
  fitmentSearch: {
    ...shopifyGenericDefaults.fitmentSearch,
    categorySelectionPageRedirect: true,
    isAutoRedirectDisabled: true,
  },
  Widgets: [
    ...shopifyGenericDefaults.Widgets.filter(
      (w) => !['SearchBox', 'HeaderVehicleWidget', 'HomeVehicleWidget_tab', 'VerifyFitment'].includes(w.name),
    ),
    {
      ...shopifyGenericDefaults.Widgets.find((w) => w.name === 'SearchBox'),
      location: { selector: '#cm-search-box', class: 'cm-search-box cm_mobile-hide' },
    },
    {
      ...shopifyGenericDefaults.Widgets.find((w) => w.name === 'HeaderVehicleWidget'),
      visibleIf: () => !isMiniStoreCollectionPage && (isSearchPage || isCollectionPage),
    },
    {
      ...shopifyGenericDefaults.Widgets.find((w) => w.name === 'HomeVehicleWidget_tab'),
      template: 'fitmentSearch/homeVehicleWidget',
    },
    {
      ...shopifyGenericDefaults.Widgets.find((w) => w.name === 'VerifyFitment'),
      initCollapsed: false,
    },
    {
      name: 'GenericMiniStoreVehicleLabel',
      type: 'VehicleWidget',
      location: { selector: '#cm-mini-vehicle-label', class: 'cm_generic-vehicle-label' },
      template: 'fitmentSearch/genericMiniStoreVehicleLabel',
      useNativeDropdown: false,
    },
    {
      name: 'GenericMiniStoreChangeButton',
      type: 'VehicleWidget',
      location: { selector: '#cm-mini-change-button', class: 'cm_generic-change-button' },
      template: 'fitmentSearch/genericMiniStoreVehicleLabel',
      useNativeDropdown: false,
    },
    {
      name: 'MiniStoreVehicleCategories',
      type: 'FacetTiles',
      location: '#cm-mini-categories',
      template: 'facetTiles/tabs',
      facetField: 'category',
      isMultiLevel: true,
      isVehicleWidgetDisabled: true,
    },
    {
      name: 'MiniStoreSearchPage',
      type: 'SearchPage',
      location: { selector: '#cm-mini-search', class: 'cm_mini-store-search-page' },
      template: 'MainContent',
    },
  ],
};
